import { useFormField } from 'components/form/useFormField';
export const useFieldset = (props) => {
    const formField = useFormField(props, 'fieldset');
    const { inputProps } = formField;
    return Object.assign(Object.assign({}, formField), { inputProps: {
            'aria-invalid': inputProps['aria-invalid'],
            'aria-describedby': inputProps['aria-describedby']
        } });
};
